import { Controller } from "@hotwired/stimulus"

import { track } from "@client/analytics"

const weights = { never: 0, rarely: 0, sometimes: 1, often: 1, veryoften: 1 }

export default class extends Controller {
  static targets = [
    "progress",
    "question",
    "submit",
    "scrollContainer",
    "formContent",
    "resultContent",
    "positiveTitle",
    "negativeTitle",
    "positiveDescription",
    "negativeDescription",
  ]

  updateResponses(event) {
    event.preventDefault()
    const totalQuestions =
      this.element.querySelectorAll("[data-questionnaire-option]").length /
      Object.keys(weights).length
    const answeredQuestions = new Set(
      this.element.querySelectorAll("[data-questionnaire-option]:checked"),
    ).size
    const questionIndex = this.questionTargets.findIndex((question) =>
      question.contains(event.target),
    )

    this.updateProgressBar((answeredQuestions / totalQuestions) * 100)
    this.scrollToNextQuestion(questionIndex + 1)

    // Enable submit button if all questions are answered
    this.submitTarget.disabled = answeredQuestions !== totalQuestions
  }

  updateProgressBar(percentage) {
    this.progressTarget.style.width = `${percentage}%`
  }

  submitForm(event) {
    event.preventDefault()

    const positive = this.isPositiveResult()

    if (positive) {
      this.positiveTitleTarget.classList.remove("hidden")
      this.positiveDescriptionTarget.classList.add("hidden")
    } else {
      this.negativeTitleTarget.classList.remove("hidden")
      this.negativeDescriptionTarget.classList.add("hidden")
    }

    this.formContentTarget.classList.toggle("hidden")
    this.resultContentTarget.classList.toggle("hidden")

    this.trackQuizSubmitted(positive)
  }

  isPositiveResult() {
    const totalPoints = Array.from(
      this.element.querySelectorAll("[data-questionnaire-option]:checked"),
    )
      .map((input) => input.value.toLowerCase().replace(" ", ""))
      .reduce((sum, answer) => sum + weights[answer], 0)

    return totalPoints >= 4
  }

  scrollToNextQuestion(currentIndex) {
    const scrollContainer = this.scrollContainerTarget

    const allQuestionsAnswered = currentIndex >= this.questionTargets.length
    const targetElement = allQuestionsAnswered
      ? this.submitTarget
      : this.questionTargets[currentIndex]

    const topPosition = targetElement.offsetTop - scrollContainer.offsetTop
    scrollContainer.scrollTo({
      top: topPosition,
      behavior: "smooth",
    })
  }

  trackQuizSubmitted(positive) {
    track("Quiz Submitted", {
      quiz_type: "adhd",
      result: positive ? "ADHD Suggestive" : "ADHD Non Suggestive",
    })
  }
}
